module.exports = __webpack_public_path__ + "static/media/icon-with-color.3b659f65.png";